import {FEATURE_ID, FeatureId} from '@/views/content-studio/constants';

export type FeatureInfo = {
  id: FeatureId;
  name: string;
  description: string;
  asset: string;
};

const featureMap = {
  [FEATURE_ID.RESIZE]: {
    id: FEATURE_ID.RESIZE,
    name: 'Resize to Any Ratio',
    description: 'Automatically create multiple versions of your video content',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Reformat.mp4',
  },
  [FEATURE_ID.DUB]: {
    id: FEATURE_ID.DUB,
    name: 'Dub to Multiple Languages',
    description: 'Translate and dub content to reach new markets',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Dub.mp4',
  },
  [FEATURE_ID.REPHRASE]: {
    id: FEATURE_ID.REPHRASE,
    name: 'Rephrase Messaging',
    description: 'Tailor your messaging without starting from scratch',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Rephrase.mp4',
  },
  [FEATURE_ID.CAPTIONS]: {
    id: FEATURE_ID.CAPTIONS,
    name: 'Include Captions',
    description:
      'Add accurate, on-brand captions in 50+ languages with consistent styling.',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Dub.mp4', // TODO - replace
  },
  [FEATURE_ID.AI_AVATAR]: {
    id: FEATURE_ID.AI_AVATAR,
    name: 'Create AI avatar',
    description:
      'Generate a digital avatar from your video for personalized content creation',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Dub.mp4', // TODO - replace
  },
  [FEATURE_ID.UPSCALE]: {
    id: FEATURE_ID.UPSCALE,
    name: 'Upscale to any resolution',
    description: 'Upscale your video to any resolution',
    asset:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Dub.mp4', // TODO - replace
  },
};

export default function getFeatureInfo(featureId: FeatureId): FeatureInfo {
  return featureMap[featureId];
}
